import styles from "./AddCompaniesSidebar.module.scss";
import clsx from "clsx";
import { sections } from "../const/const";
import { Section } from "./Section/Section";

export type TAddCompaniesSidebarProps = {
  className?: string;
  activeItem: string;
  passedItems: { itemName: string; description: string }[];
  setItem: (itemName: string) => void;
};

export function AddCompaniesSidebar({ activeItem, passedItems, className, setItem }: TAddCompaniesSidebarProps) {
  return (
    <div className={clsx(styles.sidebar, className)}>
      <div className={styles.verticalLine} />
      {sections.map((section) => {
        const { itemName, description, icon } = section;
        return (
          <div onClick={() => setItem(itemName)} key={itemName}>
            <Section
              key={itemName}
              icon={icon}
              itemName={itemName}
              description={description}
              isActive={activeItem === itemName}
              isPassed={passedItems.map((item) => item.itemName).includes(itemName)}
            />
          </div>
        );
      })}
    </div>
  );
}
